import React, { useState } from "react";
import Button from "@material-ui/core/Button";
import Dialog from "@material-ui/core/Dialog";
import DialogActions from "@material-ui/core/DialogActions";
import DialogTitle from "@material-ui/core/DialogTitle";
import DialogContent from "@material-ui/core/DialogContent";
import IconButton from "@material-ui/core/IconButton";
import EditIcon from "@material-ui/icons/Edit";
import TextField from "@material-ui/core/TextField";
import { Box } from "@material-ui/core";

import PageLoader from "@jumbo/components/PageComponents/PageLoader";

import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";

import api from "services/api";
import Swal from "sweetalert2";
import { getToken } from "services/auth";

const schema = yup
  .object({
    motivo: yup.string().required("Motivo é obrigatório")
  })
  .required();

export default function UpdateMotivo(props) {
  const [open, setOpen] = useState(false);
  const headers = { Authorization: "Bearer " + getToken() };
  const [isLoading, setIsLoading] = useState(false);

  const {
    register,
    handleSubmit,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(schema)
  });

  const [motivo, setMotivo] = useState();

  const onChangeItem = props.onChangeItem;
  const id = props.id;
  const nome = props.nome;

  const handleUp = () => {
    setIsLoading(true);
    const id = props.id;
    try {
      api
        .patch(`ponto/motivos/${id}`, { descricao: motivo }, { headers })
        .then(res => {
          setIsLoading(false);
          Swal.fire({
            icon: "success",
            confirmButtonColor: "#3085d6",
            title: "Uhul!",
            text: "Motivo atualizado."
          });
          handleClose();
          onChangeItem({ id: id, nome: motivo });
        })
        .catch(err => {
          Swal.fire({
            icon: "error",
            confirmButtonColor: "#3085d6",
            title: "Oops...",
            text: "Não poi possível atualizar o Motivo"
          });
        });
    } catch (err) {
      Swal.fire({
        icon: "error",
        confirmButtonColor: "#3085D6",
        title: "Oops...",
        text: "Não conseguimos conectar na api"
      });
    }
    setIsLoading(false);
    onChangeItem({ id: id, nome: motivo });
  };

  const handleClickOpen = () => {
    setOpen(true);
  };

  const handleClose = () => {
    setOpen(false);
  };

  return (
    <Box>
      <IconButton
        color="primary"
        aria-label="Editar Motivo"
        title="Editar Motivo"
        onClick={handleClickOpen}
      >
        <EditIcon fontSize="large" />
      </IconButton>

      <Dialog
        open={open}
        onClose={handleClose}
        fullWidth
        aria-labelledby="editar-motivo"
      >
        <DialogTitle id="editar-motivo">Editar Motivo</DialogTitle>
        <DialogContent>
          <TextField
            autoFocus
            fullWidth
            margin="dense"
            id="name"
            label="Descrição"
            type="text"
            defaultValue={nome}
            name="motivo"
            error={errors.motivo ? true : false}
            helperText={errors.motivo?.message}
            {...register("motivo", {
              required: true,
              onChange: e => setMotivo(e.target.value)
            })}
          />
        </DialogContent>
        <DialogActions>
          {isLoading == true ? (
            <PageLoader />
          ) : (
            <div>
              <Button onClick={handleClose} color="secondary">
                Cancelar
              </Button>
              <Button onClick={handleSubmit(handleUp)} color="primary">
                Salvar
              </Button>
            </div>
          )}
        </DialogActions>
      </Dialog>
    </Box>
  );
}
